export default "__VITE_ASSET__DWgokCJP__"